<template>
    <div v-b-tooltip.hover id="deliverable__type__icon" :title="deliverableType">
        <div class="media-call-icon pointer-default">
            <img :src="require(`@/csmworkflow/img/${deliverableTypeIcon}.svg`)"/>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    props: ['deliverableTypeId'],
    data() {
        return {
            deliverableType: ''
        }
    },
    computed: {
        ...mapGetters([
            'deliverableTypes'
        ]),
        deliverableTypeIcon() {
            let icon = '';
            let typeData = _.filter(this.deliverableTypes, {typeId: this.deliverableTypeId});
            if(typeData.length > 0) {
                icon = typeData[0].typeIcon;
                this.deliverableType = typeData[0].name;
                try {
                    let fileCheck = require(`@/csmworkflow/img/${icon}.svg`);
                } catch (e) {
                    icon = 'media-call';
                }
            } else {
                icon = 'media-call';
                this.deliverableType = 'Deliverable';
            }
            
            return icon;
        }
    }
}
</script>

<style>

</style>